import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Master from "./Components/Layouts/Master";
import Home from "./Components/Home";
import Hero from "./Components/Hero";
import Products from "./Components/Products";
import WhyChooseUs from "./Components/ProductList";
import ProductList from "./Components/ProductList";
import Contact from "./Components/Contact";
import AboutUs from "./Components/AboutUs";

import ProductAuth from "./Components/ProductAuth";
import ProductsSingle from "./Components/ProductsSingle";
import { ProductsData } from "./Components/ProductsData";

import TabletsSection from "./Components/TabletsSection";

import PeptidesSection from "./Components/PeptidesSection";
import InjectableSection from "./Components/InjectibleSection";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="" element={<Master />}>
            <Route index element={<Home />} />
            <Route path="" element={<Hero />} />
            <Route path="" element={<Products />} />
            <Route path="products" element={<ProductList/>} />
            <Route path="contact" element={<Contact/>} />
            <Route path="aboutus" element={<AboutUs/>} />
            <Route path="productauth" element={<ProductAuth/>} />
           <Route path="/product/:id" element={<ProductsSingle />} />
            <Route path="productsdata" element={<ProductsData/>} />
      
            <Route path="tabletssection" element={<TabletsSection/>} />
            <Route path="injectableSection" element={<InjectableSection/>} />
            <Route path="peptidesSection" element={<PeptidesSection/>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
